import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chart } from 'primereact/chart';
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';

import { Grid, Dialog, Button, IconButton, Select, MenuItem, FormControl, InputLabel, TextField, DialogTitle, DialogContent, DialogActions, useTheme, useMediaQuery } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';

import './modalMasTotales.css';

import { iniUpdateBudget, budgetsUpdateMontosFinalNotSave, iniUpdateBudgetModeTemplate } from '../../../redux/actions/pptos';

const percentRentaList = [
    { id: "0-8", nombre: '18%', value: 18, recibo: false },
    { id: "1-8", nombre: '8%', value: 8, recibo: true },
    { id: "2-14", nombre: '14%', value: 14, recibo: true },
    { id: "3-17", nombre: '17%', value: 17, recibo: true },
    { id: "4-20", nombre: '20%', value: 20, recibo: true },
    { id: "5-30", nombre: '30%', value: 30, recibo: true }
]

export const PptosMasTotales = ({ open, setOpen }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // móvil: sm o menor

    const dispatch = useDispatch();

    const { listaTiposDocumentos } = useSelector(state => state.general);
    const { imp_venta_nombre } = useSelector(state => state.general.detail);

    const detailBudget = useSelector(state => state.ppto.detail)
    const {
        descuento, descuento_porcentaje, total_cliente, total_impuesto, total, afecto, total_utilidad_p, total_gasto_p, margen_utilidad_p, margen_gasto_p, separacion_miles, separacion_decimales, simbolo, sub_total, porcentaje_impuesto,
        reading_mode, template_mode, id_tipo_documento,
        sobrecargo_gg, sobrecargo_gg_porcentaje, sobrecargo_utilidad, sobrecargo_utilidad_porcentaje, total_costos_directos
    } = detailBudget

    const [form, setForm] = useState({
        descuento: descuento,
        descuento_porcentaje: descuento_porcentaje,
        total_cliente: total_cliente,
        afecto: afecto,
        total_impuesto: total_impuesto,
        id_tipo_documento: id_tipo_documento,
        porcentaje_impuesto: porcentaje_impuesto,
        tipo_calculo: 'directo',
        total: total,
        total_utilidad_p: total_utilidad_p,
        total_gasto_p: total_gasto_p,
        margen_utilidad_p: margen_utilidad_p,
        margen_gasto_p: margen_gasto_p,
        sub_total: sub_total,
        sobrecargo_gg: sobrecargo_gg,
        sobrecargo_gg_porcentaje: sobrecargo_gg_porcentaje,
        sobrecargo_utilidad: sobrecargo_utilidad,
        sobrecargo_utilidad_porcentaje: sobrecargo_utilidad_porcentaje,
        total_costos_directos: total_costos_directos,
    });

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        });
    }

    const handleChangeDscto = (data) => {
        if (!reading_mode) {

            const { floatValue, sourceInfo } = data
            const name = sourceInfo?.event?.target?.name || ''

            if (name === 'descuento_porcentaje') {
                const factor = floatValue / 100
                const newPorcentaje = floatValue
                const newDescuento = form.sub_total * factor
                const newTotalCliente = form.sub_total - newDescuento
                const newTotalImpuesto = form.afecto ? (newTotalCliente * (form.porcentaje_impuesto / 100)) : 0
                const newTotal = newTotalCliente + newTotalImpuesto
                const newUtilidadP = newTotalCliente - form.total_gasto_p
                const newMargenUtilidadP = parseFloat(((newUtilidadP / newTotalCliente) * 100).toFixed(2))
                const newMargenGastoP = parseFloat(((form.total_gasto_p / newTotalCliente) * 100).toFixed(2))
                setForm({
                    ...form,
                    'descuento_porcentaje': !isNaN(newPorcentaje) ? newPorcentaje : 0,
                    'descuento': !isNaN(newDescuento) ? newDescuento : 0,
                    'total_cliente': !isNaN(newTotalCliente) ? newTotalCliente : 0,
                    'total_impuesto': !isNaN(newTotalImpuesto) ? newTotalImpuesto : 0,
                    'total': !isNaN(newTotal) ? newTotal : 0,
                    'total_utilidad_p': !isNaN(newUtilidadP) ? newUtilidadP : 0,
                    'margen_gasto_p': !isNaN(newMargenGastoP) ? newMargenGastoP : 0,
                    'margen_utilidad_p': !isNaN(newMargenUtilidadP) ? newMargenUtilidadP : 0
                })
            }

            if (name === 'descuento') {
                const newDescuento = floatValue
                const newPorcentaje = (newDescuento / form.sub_total) * 100
                const newTotalCliente = form.sub_total - newDescuento
                const newTotalImpuesto = form.afecto ? (newTotalCliente * (form.porcentaje_impuesto / 100)) : 0
                const newTotal = newTotalCliente + newTotalImpuesto
                const newUtilidadP = newTotalCliente - form.total_gasto_p
                const newMargenUtilidadP = parseFloat(((newUtilidadP / newTotalCliente) * 100).toFixed(2))
                const newMargenGastoP = parseFloat(((form.total_gasto_p / newTotalCliente) * 100).toFixed(2))
                setForm({
                    ...form,
                    'descuento_porcentaje': !isNaN(newPorcentaje) ? newPorcentaje : 0,
                    'descuento': !isNaN(newDescuento) ? newDescuento : 0,
                    'total_cliente': !isNaN(newTotalCliente) ? newTotalCliente : 0,
                    'total_impuesto': !isNaN(newTotalImpuesto) ? newTotalImpuesto : 0,
                    'total': !isNaN(newTotal) ? newTotal : 0,
                    'total_utilidad_p': !isNaN(newUtilidadP) ? newUtilidadP : 0,
                    'margen_gasto_p': !isNaN(newMargenGastoP) ? newMargenGastoP : 0,
                    'margen_utilidad_p': !isNaN(newMargenUtilidadP) ? newMargenUtilidadP : 0
                })
            }

        }
    }

    const handleChangeTipoDoc = ({ target }) => {
        if (!reading_mode) {

            const { value: newIdDoc } = target

            const found = listaTiposDocumentos.find(it => it.id === newIdDoc)
            if (found) {

                const newPercent = parseFloat(found.impuestos[0]?.porcentaje_impuesto || 0)
                const tipoCalculo = found.impuestos[0]?.tipo_calculo || 'directo'

                let factor = 0
                let newTotalImpuesto = 0
                let newTotal = 0

                if (tipoCalculo === 'retencion') {

                    factor = (1 - (newPercent / 100))
                    newTotal = form.total_cliente / factor
                    newTotalImpuesto = newTotal - form.total_cliente

                } else {

                    factor = newPercent / 100
                    newTotalImpuesto = form.total_cliente * factor
                    newTotal = form.total_cliente + newTotalImpuesto
                }

                const afecto = (newPercent > 0 ? true : false)

                setForm({
                    ...form,
                    afecto: afecto,
                    id_tipo_documento: newIdDoc,
                    tipo_calculo: tipoCalculo,
                    porcentaje_impuesto: newPercent,
                    total_impuesto: newTotalImpuesto,
                    total: newTotal,
                })

            }

        }
    }

    const handleChangePercentDoc = ({ target }) => {
        if (!reading_mode) {

            const newPercent = parseFloat(target.value || 0)

            let factor = 0
            let newTotalImpuesto = 0
            let newTotal = 0

            if (form.tipo_calculo === 'retencion') {

                factor = (1 - (newPercent / 100))
                newTotal = form.total_cliente / factor
                newTotalImpuesto = newTotal - form.total_cliente

            } else {

                factor = newPercent / 100
                newTotalImpuesto = form.total_cliente * factor
                newTotal = form.total_cliente + newTotalImpuesto
            }

            const afecto = (newPercent > 0 ? true : false)

            setForm({
                ...form,
                afecto: afecto,
                porcentaje_impuesto: newPercent,
                total_impuesto: newTotalImpuesto,
                total: newTotal,
            })

        }
    }

    const handleChangeSobrecargo = (data) => {
        if (!reading_mode) {

            const { floatValue, sourceInfo } = data
            const name = sourceInfo?.event?.target?.name || ''

            if (name === 'sobrecargo_gg_porcentaje') {
                const newPercent = floatValue
                const factor = newPercent / 100
                const subTotalDescontado = (form.sub_total - (form?.descuento || 0))
                const newTotalGG = subTotalDescontado * factor

                const totalVentaNeta = subTotalDescontado + newTotalGG + (form?.sobrecargo_utilidad || 0)
                const newTotalImpuesto = form.afecto ? (totalVentaNeta * (form.porcentaje_impuesto / 100)) : 0
                const newTotal = totalVentaNeta + newTotalImpuesto

                const totalCostosNeto = (form?.total_costos_directos || 0) + newTotalGG
                const totalRentabilidadNeta = totalVentaNeta - totalCostosNeto
                const margenRentabilidadNeta = parseFloat(((totalRentabilidadNeta / totalVentaNeta) * 100).toFixed(2))
                const newMargenGastoP = parseFloat(((totalCostosNeto / totalVentaNeta) * 100).toFixed(2))
                //const newMargenGastoP = parseFloat(((totalCostosNeto / subTotalDescontado) * 100).toFixed(2))

                setForm({
                    ...form,
                    sobrecargo_gg_porcentaje: newPercent,
                    sobrecargo_gg: newTotalGG,
                    total_cliente: totalVentaNeta,
                    total_impuesto: newTotalImpuesto,
                    total: newTotal,
                    total_utilidad_p: totalRentabilidadNeta,
                    margen_utilidad_p: margenRentabilidadNeta,
                    total_gasto_p: totalCostosNeto,
                    margen_gasto_p: newMargenGastoP
                })
            }

            if (name === 'sobrecargo_utilidad_porcentaje') {
                const newPercent = floatValue
                const factor = newPercent / 100
                const subTotalDescontado = (form.sub_total - (form?.descuento || 0))
                const totalSobrecargoUtilidad = subTotalDescontado * factor

                const totalSobrecargoGG = (form?.sobrecargo_gg || 0)
                const totalVentaNeta = subTotalDescontado + totalSobrecargoGG + (totalSobrecargoUtilidad || 0)
                const newTotalImpuesto = form.afecto ? (totalVentaNeta * (form.porcentaje_impuesto / 100)) : 0
                const newTotal = totalVentaNeta + newTotalImpuesto

                const totalCostosNeto = (form?.total_costos_directos || 0) + totalSobrecargoGG
                const totalRentabilidadNeta = totalVentaNeta - totalCostosNeto
                const margenRentabilidadNeta = parseFloat(((totalRentabilidadNeta / totalVentaNeta) * 100).toFixed(2))
                const newMargenGastoP = parseFloat(((totalCostosNeto / totalVentaNeta) * 100).toFixed(2))
                //const newMargenGastoP = parseFloat(((totalCostosNeto / subTotalDescontado) * 100).toFixed(2))

                setForm({
                    ...form,
                    sobrecargo_utilidad_porcentaje: newPercent,
                    sobrecargo_utilidad: totalSobrecargoUtilidad,
                    total_cliente: totalVentaNeta,
                    total_impuesto: newTotalImpuesto,
                    total: newTotal,
                    total_utilidad_p: totalRentabilidadNeta,
                    margen_utilidad_p: margenRentabilidadNeta,
                    total_gasto_p: totalCostosNeto,
                    margen_gasto_p: newMargenGastoP
                })
            }

        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!reading_mode) {

            const newDetail = {
                ...detailBudget,
                descuento: form.descuento,
                descuento_porcentaje: form.descuento_porcentaje,
                total_cliente: form.total_cliente,
                afecto: form.afecto,
                total_impuesto: form.total_impuesto,
                total: form.total_final,
                total_utilidad_p: form.total_utilidad_p,
                margen_gasto_p: form.margen_gasto_p,
                margen_utilidad_p: form.margen_utilidad_p,
                id_tipo_documento: form.id_tipo_documento,
                porcentaje_impuesto: form.porcentaje_impuesto,
                tipo_calculo: form.tipo_calculo,
                sobrecargo_gg: form.sobrecargo_gg,
                sobrecargo_gg_porcentaje: form.sobrecargo_gg_porcentaje,
                sobrecargo_utilidad: form.sobrecargo_utilidad,
                sobrecargo_utilidad_porcentaje: form.sobrecargo_utilidad_porcentaje
            };

            if (newDetail.id > 0 && !template_mode) {

                /* const originalDetailRaw = localStorage.getItem('budget-detail-init-data')
                const originalDetailObj = originalDetailRaw ? JSON.parse(originalDetailRaw) : null
                const isDirty = JSON.stringify(newDetail) !== JSON.stringify(originalDetailObj)

                console.log({
                    isDirty,
                    new: JSON.stringify(newDetail),
                    old: JSON.stringify(originalDetailObj)
                });

                if (!isDirty) {
                    toast.info('No se han detectado cambios para guardar')
                    return false
                } */

                dispatch(iniUpdateBudget(newDetail))

            } else {

                if (template_mode) {
                    dispatch(iniUpdateBudgetModeTemplate(newDetail))
                } else {
                    dispatch(budgetsUpdateMontosFinalNotSave(newDetail))
                    toast.success('presupuesto actualizado');
                }

            }

        }
    }

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
            fullScreen={isMobile}
            PaperProps={{
                className: isMobile ? '' : 'min-w-[70%]'
            }}
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle id="scroll-dialog-title">

                    <IconButton
                        aria-label="close"
                        style={{ padding: '0', float: 'right' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon style={{ color: '#78667E' }} />
                    </IconButton>

                    <div className='d-flex align-items-center mt-3' style={{ fontSize: '20px' }}>
                        Monto final
                        {reading_mode &&
                            <div className='ms-2' style={{ color: '#8E24AA', fontSize: '15px' }}>
                                <i className="bi bi-eye"></i>
                                <span className='ms-1'>Modo: lectura</span>
                            </div>
                        }
                    </div>


                </DialogTitle>
                <DialogContent>
                    <div style={{ marginTop: '30px' }}>
                        <Grid container spacing={5}>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

                                    <Grid item xs={12}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Total costos directos"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name="sub_total"
                                                value={form?.total_costos_directos || (form?.total_gasto_p || 0)}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                onChange={handleChange}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Subtotal de ítems"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name="sub_total"
                                                value={form.sub_total || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                onChange={handleChange}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="% dscto"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="descuento_porcentaje"
                                                value={form.descuento_porcentaje || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                suffix={`%`}
                                                onValueChange={(values, sourceInfo) => handleChangeDscto({ ...values, sourceInfo }, 'descuento_porcentaje')}
                                                disabled={reading_mode}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Monto dscto"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="descuento"
                                                value={form.descuento || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                onValueChange={(values, sourceInfo) => handleChangeDscto({ ...values, sourceInfo }, 'descuento')}
                                                disabled={reading_mode}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    {form.descuento > 0 &&
                                        <Grid item xs={12}>
                                            <div className='p-montos-mas-totales-2'>
                                                <NumberFormat
                                                    customInput={TextField}
                                                    label="Subtotal con descuento"
                                                    id="outlined-size-small"
                                                    size="small"
                                                    disabled
                                                    fullWidth
                                                    value={(form.sub_total - (form?.descuento || 0))}
                                                    thousandSeparator={separacion_miles}
                                                    decimalSeparator={separacion_decimales}
                                                    prefix={`${simbolo} `}
                                                    decimalScale={2}
                                                    fixedDecimalScale
                                                />
                                            </div>
                                        </Grid>
                                    }

                                    <Grid item xs={12} sm={12} className='mt-2'>
                                        <span className="font-extrabold text-[14px]">Sobrecargos:</span>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="% Gastos Generales"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="sobrecargo_gg_porcentaje"
                                                value={form.sobrecargo_gg_porcentaje || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                suffix={`%`}
                                                onValueChange={(values, sourceInfo) => handleChangeSobrecargo({ ...values, sourceInfo }, 'sobrecargo_gg_porcentaje')}
                                                disabled={reading_mode}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Total Gastos Generales (+ costos indirectos)"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="sobrecargo_gg"
                                                value={form.sobrecargo_gg || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                // onValueChange={(values, sourceInfo) => handleChangeSobrecargo({ ...values, sourceInfo }, 'descuento')}
                                                disabled
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="% Utilidad"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="sobrecargo_utilidad_porcentaje"
                                                value={form.sobrecargo_utilidad_porcentaje || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                suffix={`%`}
                                                onValueChange={(values, sourceInfo) => handleChangeSobrecargo({ ...values, sourceInfo }, 'sobrecargo_utilidad_porcentaje')}
                                                disabled={reading_mode}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Total Utilidad"
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                name="sobrecargo_utilidad"
                                                value={form.sobrecargo_utilidad || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                // onValueChange={(values, sourceInfo) => handleChangeDscto({ ...values, sourceInfo }, 'descuento')}
                                                disabled
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} className='mt-5'>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label="Total Neto"
                                                id="outlined-size-small"
                                                size="small"
                                                disabled
                                                fullWidth
                                                value={form.total_cliente || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>

                                    {/* {parseInt(form.id_tipo_documento) === 4 && */}
                                    {/* <Grid item xs={12}>
                                        <FormControlLabel
                                            value="start"
                                            className='afecto-label'
                                            checked={form.afecto}
                                            control={<Switch color="primary" />}
                                            label="Afecto"
                                            labelPlacement="start"
                                            onChange={handleChangeCheck}
                                            disabled={reading_mode}
                                        />
                                    </Grid> */}
                                    {/* } */}

                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                                            <Select
                                                label="Tipo de documento"
                                                id="id_tipo_documento"
                                                name="id_tipo_documento"
                                                value={form.id_tipo_documento || ''}
                                                onChange={handleChangeTipoDoc}
                                                className='p-list-capitalize'
                                                disabled={reading_mode}
                                            >
                                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                                {listaTiposDocumentos.map(item => (
                                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel id="demo-simple-select-label">
                                                {`% ${imp_venta_nombre?.toUpperCase() || 'IGV'}`}
                                            </InputLabel>
                                            <Select
                                                label={`% ${imp_venta_nombre?.toUpperCase() || 'IGV'}`}
                                                id="porcentaje_impuesto"
                                                name="porcentaje_impuesto"
                                                value={form.porcentaje_impuesto || ''}
                                                onChange={handleChangePercentDoc}
                                                className='p-list-capitalize'
                                                disabled={reading_mode}
                                            >
                                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                                {percentRentaList.map(item => (
                                                    <MenuItem
                                                        key={item.id}
                                                        value={item.value}
                                                        className='p-list-capitalize'>
                                                        {item.nombre}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* <Grid item xs={12} sm={4}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label={`% ${imp_venta_nombre?.toUpperCase() || 'IGV'}`}
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name="porcentaje_impuesto"
                                                value={form.porcentaje_impuesto || 0}
                                                // thousandSeparator={separacion_miles}
                                                // decimalSeparator={separacion_decimales}
                                                suffix={`%`}
                                                decimalScale={2}
                                            />
                                        </div>
                                    </Grid> */}

                                    <Grid item xs={12} sm={8}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label={`Monto ${imp_venta_nombre?.toUpperCase() || 'IGV'}`}
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                disabled
                                                value={form.total_impuesto || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className='p-montos-mas-totales-2'>
                                            <NumberFormat
                                                customInput={TextField}
                                                label={`Total ${imp_venta_nombre?.toUpperCase() || 'IGV'} incluido`}
                                                id="outlined-size-small"
                                                size="small"
                                                fullWidth
                                                disabled
                                                value={form.total || 0}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                    <Grid item xs={12} >
                                        <DoughnutChartDemo
                                            data={form}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className='d-flex justify-content-between align-items-center p-2'>
                                            <span className='d-flex align-items-center'>
                                                <label style={{ width: '8px', height: '8px', background: '#36B4D0', borderRadius: '50%' }}></label>
                                                <label className='ms-2'>Total neto</label>
                                            </span>
                                            <NumberFormat
                                                value={form.total_cliente || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center p-2'>
                                            <span className='d-flex align-items-center'>
                                                <label style={{ width: '8px', height: '8px', background: '#FF4A4A', borderRadius: '50%' }}></label>
                                                <label className='ms-2'>Gasto presupuestado</label>
                                            </span>
                                            <NumberFormat
                                                value={form.total_gasto_p || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center p-2'>
                                            <span className='d-flex align-items-center'>
                                                <label style={{ width: '8px', height: '8px', background: '#5CBF66', borderRadius: '50%' }}></label>
                                                <label className='ms-2'>Utilidad presupuestada</label>
                                            </span>
                                            <NumberFormat
                                                value={form.total_utilidad_p || 0}
                                                displayType={'text'}
                                                thousandSeparator={separacion_miles}
                                                decimalSeparator={separacion_decimales}
                                                prefix={`${simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>

                {!reading_mode &&
                    <DialogActions style={{ padding: '20px' }}>
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            type='submit'
                        >
                            Guardar
                        </Button>
                    </DialogActions>
                }

            </form>
        </Dialog>
    )
}


const DoughnutChartDemo = ({ data }) => {

    const chartData = {
        labels: [`${data?.margen_utilidad_p}%`, `${data?.margen_gasto_p}%`],
        datasets: [
            {
                data: [data?.total_utilidad_p, data?.total_gasto_p],
                backgroundColor: [
                    "#5CBF66",
                    "#FF4A4A",
                ],
                hoverBackgroundColor: [
                    "#5CBF66",
                    "#FF4A4A",
                ]
            }]
    }

    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    }

    return (
        <div className="d-flex justify-content-center">
            <Chart type="doughnut" data={chartData} options={lightOptions} style={{ position: 'relative', width: '70%' }} />
        </div>
    )
}